<template>
	<div>
		<h2 class="mb-3">Leaderboard Settings</h2>
		<v-card class="pa-3">
			<v-row>
				<v-row>
					<!---Image Preview-->
					<v-col ref="box" id="box" cols="12" sm="6">
						<img
							v-if="
								backgroundTemp && backgroundTemp.startsWith('data') && (backgroundImageName.toLowerCase().endsWith('.jpg') || backgroundImageName.toLowerCase().endsWith('.jpeg') || backgroundImageName.toLowerCase().endsWith('.png'))
							"
							:src="backgroundTemp"
							width="100%"
							height="auto"
						/>
						<img
							v-else-if="leaderboard.background && $root.isImage(leaderboard.background)"
							:src="$root.asset(leaderboard.background)"
							width="100%"
							height="auto"
						/>

						<video
							v-else-if="backgroundTemp && backgroundTemp.startsWith('data') && backgroundImageName.toLowerCase().endsWith('.mp4')"
							width="100%"
							height="auto"
							preload="auto"
							autoplay="autoplay"
							muted
							playsinline
							disablepictureinpicture
							loop="loop"
						>
							<source :src="editBackgroundTemp" type="video/mp4" />
						</video>
						<video v-else-if="leaderboard.background && $root.isVideo(leaderboard.background)" width="100%" preload="auto" autoplay="autoplay" muted playsinline disablepictureinpicture loop="loop">
							<source :src="leaderboard.background.toLowerCase().startsWith('http') ? leaderboard.background : baseLocation + '/asset/file/' + leaderboard.background" type="video/mp4" />
						</video>
						<div v-else style="border: 5px solid black; width: 100%; height: 350px"></div>
					</v-col>
					<!--End of image preview-->
					<v-col cols="12" sm="4">
						<v-row>
							<input ref="attachment" type="file" accept="image/png, image/jpeg, image/jpg, video/mp4" @change="onBackgroundUpload" style="display: none" />
							<v-text-field
								v-model="backgroundFileName"
								label="Background"
								placeholder="Upload Background"
								prepend-icon="mdi-image"
								@click="openBackgroundDialog()"
								readonly
								hint="It’s recommended to use image with resolution approximately 1920 x 1080 pixels and recommended size is under 2MB, and for video it's recommended to use resolution of 1080 pixels."
							></v-text-field>
						</v-row>
						<v-row>
							<v-btn color="primary" dark class="mb-2 mr-3 mt-2" @click="dialogLeaderboardLibrary = true">Choose background from library</v-btn>
						</v-row>
					</v-col>
					<v-col cols="12" sm="2">
						<v-btn color="primary" dark class="mb-2 mr-3 mt-2" @click="saveLeaderboardBackground()">Save</v-btn>
					</v-col>
				</v-row>
			</v-row>
			<v-row>
				<v-col cols="12" sm="6">
					<v-btn color="primary" dark class="mb-2 mr-3 mt-2" @click="dialogAreYouSure = true">Reset Leaderboard Point Until Now</v-btn>
				</v-col>
			</v-row>

			<!---Show leaderboard library template-->
			<v-dialog v-model="dialogLeaderboardLibrary" fullscreen>
				<v-card>
					<v-card-title class="headline">
						Choose one of the library background below
						<v-spacer></v-spacer>
						<v-btn icon @click="dialogLeaderboardLibrary = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-row>
						<v-col cols="4">
							<v-autocomplete v-model="tagFilter" :items="tagList" chips small-chips deletable-chips label="Filter by tags" multiple solo dense></v-autocomplete>
						</v-col>
						<div style="display: flex; flex-direction: row; margin-top: 13px">
							<v-btn color="primary" style="margin-right: 10px" @click="listLeaderboardLibraryList">filter</v-btn>
							<v-btn color="primary" @click="resetLibrary">Reset</v-btn>
						</div>
					</v-row>
					<v-divider class="mx-4"></v-divider>
					<div class="d-flex flex-wrap justify-space-around align-stretch">
						<v-hover v-for="(library, idxLibrary) in leaderboardLibraryList.data" :key="idxLibrary" v-slot:default="{ hover }">
							<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5">
								<div id="structure-view" style="display: block">
									<div class="entry-view">
										<v-img v-if="$root.isImage(library.background)" :src="$root.asset(library.background)" max-height="200" min-height="200" @click="closeLibraryDialog(library)"></v-img>
										<video
											v-else-if="$root.isVideo(library.background)"
											width="100%"
											style="max-height: 200px;min-height=200"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
											@click="closeLibraryDialog(library)"
										>
											<source :src="$root.asset(library.background)" type="video/mp4" />
										</video>
									</div>
								</div>
							</v-card>
						</v-hover>
					</div>

					<div class="d-flex flex-wrap justify-space-between" style="margin: 0px 20px 0px 30px">
						<div class="d-inline-flex">
							<span style="margin-top: 10px"> Rows per page : </span>
							<v-select
								v-model="leaderboardLibraryList.size"
								:items="rowsPerPage"
								style="margin-left: 10px; width: 80px"
								@change="listLeaderboardLibrary()"
								hide-details=""
								solo
							></v-select>
						</div>

						<v-pagination
							v-model="leaderboardLibraryList.page"
							:length="leaderboardLibraryList.length"
							:total-visible="7"
							@input="listLeaderboardLibrary()"
						></v-pagination>
					</div>
				</v-card>
			</v-dialog>

			<!---Confirmation to reset leaderboard point-->
			<v-dialog v-model="dialogAreYouSure" max-width="500">
				<v-card>
					<v-card-title class="headline">Reset Leaderboard Points</v-card-title>
					<v-card-text>Are you sure to reset leaderboard points?</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="red darken-1" text @click="dialogAreYouSure = false">CANCEL</v-btn>
						<v-btn
							color="green darken-1"
							text
							@click="
								resetLeaderboardPoint();
								dialogAreYouSure = false;
							"
							>YES</v-btn
						>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!---Reset leaderboard point success-->
			<v-dialog v-model="dialogResetSuccess" max-width="500">
				<v-card>
					<v-card-title class="headline">Sucessfully Reset Leaderboard Points</v-card-title>
					<v-card-text>You have successfully reset leaderboard points for this experience!</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="green darken-1" text @click="dialogResetSuccess = false">OK</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!---Save leaderboard success-->
			<v-dialog v-model="dialogSuccess" max-width="500">
				<v-card>
					<v-card-title class="headline">Sucessfully Save Leaderboard</v-card-title>
					<v-card-text>Leaderboard successfully saved</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="green darken-1" text @click="dialogSuccess = false">OK</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-card class="mt-2 mb-2">
				<!--POINT SYSTEM TABLE-->
				<v-data-table :headers="headers" :items="leaderboard.pointSystemList">
					<template v-slot:top>
						<v-toolbar flat color="white">
							<v-toolbar-title class="mt-2">Point Systems</v-toolbar-title>
							<v-spacer></v-spacer>
							<!--ADD DIALOG POINT SYSTEM-->
							<v-dialog v-model="isAddDialog" max-width="500px">
								<template v-slot:activator="{ on, attrs }">
									<v-btn color="primary" dark class="mb-2 mr-3 mt-2" v-bind="attrs" v-on="on">New Point System</v-btn>
								</template>
								<v-card>
									<v-form v-model="isValidForm">
										<v-card-title>
											<span class="headline">New Point System</span>
										</v-card-title>

										<v-card-text>
											<v-container>
												<v-row>
													<v-col cols="12" class="pb-1">
														<v-text-field v-model="pointSystemNew.title" placeholder="Title" rounded filled hint="This title will be shown in the experience's leaderboard" persistent-hint> </v-text-field>
													</v-col>
													<v-col cols="12" class="pb-1">
														<v-select
															v-model="pointSystemNew.description"
															placeholder="Points system"
															:items="pointDescriptionList"
															:rules="fieldRules"
															rounded
															filled
															@change="changeLinkToList(), (pointSystemNew.specificId = [])"
														>
															<template v-slot:selection="{ item }">
																<span>{{ item.replace(/_/g, " ") }}</span>
															</template>
															<template v-slot:item="{ item }">
																<span>{{ item.replace(/_/g, " ") }}</span>
															</template>
														</v-select>
													</v-col>
													<v-col
														cols="12"
														class="pb-1"
														v-if="
															pointSystemNew.description == 'Visit_room' ||
															pointSystemNew.description == 'Watch_live_presentation' ||
															pointSystemNew.description == 'Watch_presentation_video' ||
															pointSystemNew.description == 'Room_url_current_tab' ||
															pointSystemNew.description == 'Room_url_new_tab' ||
															pointSystemNew.description == 'Watch_video_in_room'
														"
													>
														<v-checkbox v-model="isSpecific" label="This point system is specific" persistent-hint hint="Attendee have to visit all the id that selected in this point system to gain point"></v-checkbox>
													</v-col>
													<!---Selec specific rooms--->
													<v-col cols="12" v-if="pointSystemNew.description == 'Visit_room' && isSpecific">
														<v-select v-model="pointSystemNew.specificId" label="Select Room" :items="roomList" :item-text="(item) => item.id + ' - ' + item.name" item-value="id" multiple rounded filled chips>
															<template v-slot:selection="{ item }">
																<v-chip color="primary" dark small> {{ item.id }} - {{ item.name }}</v-chip>
															</template>
														</v-select>
													</v-col>
													<v-col cols="12" class="pb-1" v-if="pointSystemNew.description == 'Navigation_url'">
														<v-text-field v-model="pointSystemNew.specificValueData" placeholder="Link" rounded filled persistent-hint hint="Attendee have to visit all links, specify link value visited i.e. https://link1.com, https://link2.com"> </v-text-field>
													</v-col>
													<!---Selec live presentation--->
													<v-col cols="12" v-if="pointSystemNew.description == 'Watch_live_presentation' && isSpecific">
														<v-select
															v-model="pointSystemNew.specificId"
															label="Select Live Presentation"
															:items="livePresentationList"
															:item-text="(item) => item.id + ' - ' + item.title"
															item-value="id"
															multiple
															rounded
															filled
															chips
														>
															<template v-slot:selection="{ item }">
																<v-chip color="primary" dark small> {{ item.id }} - {{ item.title }}</v-chip>
															</template>
														</v-select>
													</v-col>
													<!---Selec non live presentation--->
													<v-col cols="12" v-if="pointSystemNew.description == 'Watch_presentation_video' && isSpecific">
														<v-select
															v-model="pointSystemNew.specificId"
															label="Select Non Live Presentation"
															:items="nonlivePresentationList"
															:item-text="(item) => item.id + ' - ' + item.title"
															item-value="id"
															multiple
															rounded
															filled
															chips
														>
															<template v-slot:selection="{ item }">
																<v-chip color="primary" dark small> {{ item.id }} - {{ item.title }}</v-chip>
															</template>
														</v-select>
													</v-col>
													<!---Selec specific rooms for link to--->
													<v-col
														cols="12"
														v-if="(pointSystemNew.description == 'Room_url_current_tab' || pointSystemNew.description == 'Room_url_new_tab' || pointSystemNew.description == 'Watch_video_in_room') && isSpecific"
													>
														<v-select v-model="pointSystemNew.specificLinkTo.roomId" label="Select Room" :items="roomList" item-text="name" item-value="id" rounded filled chips @change="changeLinkToList">
															<template v-slot:selection="{ item }">
																<v-chip color="primary" dark small> {{ item.name }}</v-chip>
															</template>
														</v-select>
													</v-col>
													<!---Select specific link to--->
													<v-col
														cols="12"
														v-if="
															linkToList.length > 0 &&
															(pointSystemNew.description == 'Room_url_current_tab' || pointSystemNew.description == 'Room_url_new_tab' || pointSystemNew.description == 'Watch_video_in_room') &&
															isSpecific
														"
													>
														<v-select
															v-model="pointSystemNew.specificLinkTo.linkToId"
															label="Select Link To"
															:items="linkToList"
															:item-text="(item) => item.id + ' - ' + item.value"
															item-value="id"
															multiple
															rounded
															filled
															chips
														>
															<template v-slot:selection="{ item }">
																<v-chip color="primary" dark small> {{ item.id }} - {{ item.value }}</v-chip>
															</template>
														</v-select>
													</v-col>
													<v-col cols="12">
														<v-text-field v-model="pointSystemNew.point" placeholder="Points earned" :rules="fieldRules" type="number" min="0" rounded filled></v-text-field>
													</v-col>
													<v-col cols="12" class="pb-1" v-if="pointSystemNew.description == 'Visit_room' ||
															pointSystemNew.description == 'Watch_live_presentation' ||
															pointSystemNew.description == 'Watch_presentation_video' ||
															pointSystemNew.description == 'Room_url_current_tab' ||
															pointSystemNew.description == 'Room_url_new_tab' ||
															pointSystemNew.description == 'Watch_video_in_room' ||
															pointSystemNew.description == 'Navigation_url'">
														<p>Count points per one visit each</p>
														<v-switch v-model="pointSystemNew.countPerOneVisit" :label="pointSystemNew.countPerOneVisit ? 'Active' : 'Inactive'" :disabled="!pointSystemNew.specificValueData && pointSystemNew.specificId.length <= 0"></v-switch>
													</v-col>
												</v-row>
											</v-container>
										</v-card-text>
										<v-alert class="ma-2" type="error" v-if="error.show">{{ error.content }}</v-alert>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn
												color="red darken-3 white--text"
												@click="
													isAddDialog = false;
													error.show = false;
												"
												>Cancel</v-btn
											>
											<v-btn :disabled="!isValidForm" type="submit" color="primary darken-1" @click="addPointSystem()">Add</v-btn>
										</v-card-actions>
									</v-form>
								</v-card>
							</v-dialog>
						</v-toolbar>
					</template>
					<template v-slot:item.title="{ item }">
						<div style="max-width: 300px; word-wrap: break-word" v-if="item.title != undefined">
							{{ item.title }}
						</div>
					</template>
					<template v-slot:item.description="{ item }">
						<div row v-if="item.specificId != null && item.specificId.length > 0" style="display: inline-block">
							{{ item.description.replace(/_/g, " ") }} -
							<span v-for="(specific, index) in item.specificId" :key="index">
								<p v-if="item.description == 'Visit_room' && roomList.find((room) => room.id === specific) != null" style="display: inline">
									{{ roomList.find((room) => room.id === specific).name }}
								</p>
								<p v-else-if="item.description == 'Watch_live_presentation' && livePresentationList.find((livePresentation) => livePresentation.id === specific) != null" style="display: inline">
									{{ livePresentationList.find((livePresentation) => livePresentation.id === specific).title }}
								</p>
								<p v-else-if="item.description == 'Watch_presentation_video' && nonlivePresentationList.find((nonlivePresentation) => nonlivePresentation.id === specific) != null" style="display: inline">
									{{ nonlivePresentationList.find((nonlivePresentation) => nonlivePresentation.id === specific).title }}
								</p>
								<p v-else style="display: inline">
									{{ specific }}
								</p>
								<p v-if="index != item.specificId.length - 1" style="display: inline">,&nbsp;</p>
							</span>
						</div>
						<div row v-else-if="item.specificLinkTo && item.specificLinkTo.linkToId != null && item.specificLinkTo.linkToId.length > 0" style="display: inline-block">
							{{ item.description.replace(/_/g, " ") }} -

							<p v-if="roomList.find((room) => room.id === item.specificLinkTo.roomId) != null" style="display: inline">
								{{ roomList.find((room) => room.id === item.specificLinkTo.roomId).name }}
							</p>
							<p v-else style="display: inline">
								{{ item.specificLinkTo.roomId }}
							</p>
							<p style="display: inline">{{ item.specificLinkTo.linkToId }}</p>
						</div>
						<span v-else>{{ item.description.replace(/_/g, " ") }}</span>
					</template>
					<template v-slot:item.actions="{ item }">
						<v-icon
							small
							class="mr-2"
							@click="(isEditDialog = true), (selectedPointSystem = item), (selectedPointSystemEdit = $root.clone({ ...item })), (isSpecificEdit = item.specificId.length > 0 || Object.keys(item.specificLinkTo).length > 0 ? true : false), changeLinkToListEdit()"
							>mdi-pencil</v-icon
						>
						<v-icon small @click="(isDeleteDialog = true), (selectedPointSystem = item)">mdi-delete</v-icon>
					</template>
				</v-data-table>

				<!--EDIT DIALOG POINT SYSTEM-->
				<v-dialog v-model="isEditDialog" max-width="500px">
					<v-card>
						<v-form v-model="isValidForm">
							<v-card-title>
								<span class="headline">Edit Point System</span>
							</v-card-title>

							<v-card-text>
								<v-container>
									<v-row>
										<v-col cols="12" class="pb-1">
											<v-text-field v-model="selectedPointSystemEdit.title" placeholder="Title" rounded filled hint="This title will be shown in the experience's leaderboard" persistent-hint> </v-text-field>
										</v-col>
										<v-col cols="12">
											<v-select
												v-model="selectedPointSystemEdit.description"
												placeholder="Points system"
												:items="pointDescriptionList"
												:rules="fieldRules"
												rounded
												filled
												@change="(isEditRoomChanged = true), changeLinkToListEdit(), (selectedPointSystemEdit.specificId = [])"
											>
												<template v-slot:selection="{ item }">
													<span>{{ item.replace(/_/g, " ") }}</span>
												</template>
												<template v-slot:item="{ item }">
													<span>{{ item.replace(/_/g, " ") }}</span>
												</template>
											</v-select>
										</v-col>

										<v-col
											cols="12"
											class="pt-1"
											v-if="
												selectedPointSystemEdit.description == 'Visit_room' ||
												selectedPointSystemEdit.description == 'Watch_live_presentation' ||
												selectedPointSystemEdit.description == 'Watch_presentation_video' ||
												selectedPointSystemEdit.description == 'Room_url_current_tab' ||
												selectedPointSystemEdit.description == 'Room_url_new_tab' ||
												selectedPointSystemEdit.description == 'Watch_video_in_room'
											"
										>
											<v-checkbox v-model="isSpecificEdit" label="This point system is specific" persistent-hint hint="Attendee have to visit all the id that selected in this point system to gain point"></v-checkbox>
										</v-col>
										<!---Select specific rooms--->
										<v-col cols="12" v-if="selectedPointSystemEdit.description == 'Visit_room' && isSpecificEdit">
											<v-select v-model="selectedPointSystemEdit.specificId" label="Select Room" :items="roomList" item-text="name" item-value="id" multiple rounded filled chips>
												<template v-slot:selection="{ item }">
													<v-chip color="primary" dark small> {{ item.name }}</v-chip>
												</template>
											</v-select>
										</v-col>
										<v-col cols="12" class="pb-1" v-if="selectedPointSystemEdit.description == 'Navigation_url'">
											<v-text-field v-model="selectedPointSystemEdit.specificValueData" placeholder="Link" rounded filled persistent-hint hint="Attendee have to visit all links, specify link value visited i.e. https://link1.com, https://link2.com" required> </v-text-field>
										</v-col>
										<!---Select live presentation--->
										<v-col cols="12" v-if="selectedPointSystemEdit.description == 'Watch_live_presentation' && isSpecificEdit">
											<v-select
												v-model="selectedPointSystemEdit.specificId"
												label="Select Live Presentation"
												:items="livePresentationList"
												:item-text="(item) => item.id + ' - ' + item.title"
												item-value="id"
												multiple
												rounded
												filled
												chips
											>
												<template v-slot:selection="{ item }">
													<v-chip color="primary" dark small> {{ item.id }} - {{ item.title }}</v-chip>
												</template>
											</v-select>
										</v-col>
										<!---Selec non live presentation--->
										<v-col cols="12" v-if="selectedPointSystemEdit.description == 'Watch_presentation_video' && isSpecificEdit">
											<v-select
												v-model="selectedPointSystemEdit.specificId"
												label="Select Non Live Presentation"
												:items="nonlivePresentationList"
												:item-text="(item) => item.id + ' - ' + item.title"
												item-value="id"
												multiple
												rounded
												filled
												chips
											>
												<template v-slot:selection="{ item }">
													<v-chip color="primary" dark small> {{ item.id }} - {{ item.title }}</v-chip>
												</template>
											</v-select>
										</v-col>

										<!---Selec specific rooms for link to--->
										<v-col
											cols="12"
											v-if="
												(selectedPointSystemEdit.description == 'Room_url_current_tab' || selectedPointSystemEdit.description == 'Room_url_new_tab' || selectedPointSystemEdit.description == 'Watch_video_in_room') &&
												isSpecificEdit
											"
										>
											<v-select
												v-model="selectedPointSystemEdit.specificLinkTo.roomId"
												label="Select Room"
												:items="roomList"
												item-text="name"
												item-value="id"
												rounded
												filled
												chips
												@change="(isEditRoomChanged = true), changeLinkToListEdit()"
											>
												<template v-slot:selection="{ item }">
													<v-chip color="primary" dark small> {{ item.name }}</v-chip>
												</template>
											</v-select>
										</v-col>
										<!---Select specific link to--->
										<v-col
											cols="12"
											v-if="
												linkToList.length > 0 &&
												(selectedPointSystemEdit.description == 'Room_url_current_tab' || selectedPointSystemEdit.description == 'Room_url_new_tab' || selectedPointSystemEdit.description == 'Watch_video_in_room') &&
												isSpecificEdit
											"
										>
											<v-select
												v-model="selectedPointSystemEdit.specificLinkTo.linkToId"
												label="Select Link To"
												:items="linkToList"
												:item-text="(item) => item.id + ' - ' + item.value"
												item-value="id"
												multiple
												rounded
												filled
												chips
											>
												<template v-slot:selection="{ item }">
													<v-chip color="primary" dark small> {{ item.id }} - {{ item.value }}</v-chip>
												</template>
											</v-select>
										</v-col>
										<v-col cols="12">
											<v-text-field v-model="selectedPointSystemEdit.point" placeholder="Points earned" :rules="fieldRules" type="number" min="0" rounded filled></v-text-field>
										</v-col>
										<v-col cols="12" class="pb-1" v-if="selectedPointSystemEdit.description == 'Visit_room' ||
												selectedPointSystemEdit.description == 'Watch_live_presentation' ||
												selectedPointSystemEdit.description == 'Watch_presentation_video' ||
												selectedPointSystemEdit.description == 'Room_url_current_tab' ||
												selectedPointSystemEdit.description == 'Room_url_new_tab' ||
												selectedPointSystemEdit.description == 'Watch_video_in_room' ||
												selectedPointSystemEdit.description == 'Navigation_url'">
											<p>Count points per one visit each</p>
											<v-switch v-model="selectedPointSystemEdit.countPerOneVisit" :label="selectedPointSystemEdit.countPerOneVisit ? 'Active' : 'Inactive'" :disabled="!selectedPointSystemEdit.specificValueData && selectedPointSystemEdit.specificId.length <= 0"></v-switch>
										</v-col>
									</v-row>
								</v-container>
							</v-card-text>
							<v-alert class="ma-2" type="error" v-if="error.show">{{ error.content }}</v-alert>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn
									color="red darken-3 white--text"
									@click="
										isEditDialog = false;
										error.show = false;
									"
									>Cancel</v-btn
								>
								<v-btn :disabled="!isValidForm" type="submit" color="primary darken-1" @click="editPointSystem()">Save</v-btn>
							</v-card-actions>
						</v-form>
					</v-card>
				</v-dialog>

				<!---DELETE DIALOG POINT SYSTEM--->
				<v-dialog v-model="isDeleteDialog" max-width="300">
					<v-card>
						<v-card-title class="headline">Delete Point System</v-card-title>
						<v-card-text>Are you sure you want to delete this point system?</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="red darken-1" text @click="isDeleteDialog = false">CANCEL</v-btn>
							<v-btn color="green darken-1" text @click="deletePointSystem(selectedPointSystem)">YES</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-card>
			<v-card class="mt-2 mb-2">
				<!--PRIZES TABLE-->
				<v-data-table :headers="headersPrize" :items="leaderboard.prizeDataList">
					<template v-slot:top>
						<v-toolbar flat color="white">
							<v-toolbar-title class="mt-2">Prizes</v-toolbar-title>
							<v-spacer></v-spacer>
							<!--ADD DIALOG PRIZE-->
							<v-dialog v-model="isAddDialogPrize" max-width="500px">
								<template v-slot:activator="{ on, attrs }">
									<v-btn color="primary" dark class="mb-2 mr-3 mt-2" v-bind="attrs" v-on="on">New Prize</v-btn>
								</template>
								<v-card>
									<v-form v-model="isValidFormPrize">
										<v-card-title>
											<span class="headline">New Prizes</span>
										</v-card-title>

										<v-card-text>
											<v-container>
												<v-row>
													<v-col cols="12" class="pb-1">
														<v-text-field v-model="prizeNew.title" placeholder="Title" rounded filled persistent-hint :rules="fieldRules"> </v-text-field>
													</v-col>
													<v-col cols="12" class="pb-1">
														<v-select v-model="prizeNew.type" placeholder="Type" :items="prizeTypeList" :rules="fieldRules" rounded filled>
															<template v-slot:selection="{ item }">
																<span>{{ item.replace(/_/g, " ") }}</span>
															</template>
															<template v-slot:item="{ item }">
																<span>{{ item.replace(/_/g, " ") }}</span>
															</template>
														</v-select>
													</v-col>
													<v-col cols="12" v-if="prizeNew.type == 'URL'">
														<v-text-field v-model="prizeNew.url" placeholder="Url" :rules="fieldRules" rounded filled></v-text-field>
													</v-col>
													<v-col cols="12" v-if="prizeNew.type == 'Text_and_image' || prizeNew.type == 'Text'">
														<v-text-field v-model="prizeNew.description" placeholder="Description" :rules="fieldRules" rounded filled></v-text-field>
													</v-col>
													<!---upload image-->
													<v-col ref="box" id="box" v-if="prizeNew.type == 'Text_and_image'">
														<img
															v-if="
																imageTemp &&
																imageTemp.startsWith('data') &&
																imageType == 'Upload' &&
																(imageName.toLowerCase().endsWith('.jpg') || imageName.toLowerCase().endsWith('.jpeg') || imageName.toLowerCase().endsWith('.png'))
															"
															:src="imageTemp"
															width="50%"
															height="150px"
															style="margin: 0 auto; display: block"
														/>
														<img
															v-else-if="prizeNew.image && imageType == 'URL' && $root.isImage(prizeNew.image)"
															:src="prizeNew.image.toLowerCase().startsWith('http') ? prizeNew.image : baseLocation + '/asset/file/' + prizeNew.image"
															width="50%"
															height="150px"
															style="margin: 0 auto; display: block"
														/>
														<div v-else style="border: 5px solid black; width: 50%; height: 150px; margin: 0 auto"></div>
														<!--- INPUT PRIZE IMAGE-->
														<v-row>
															<v-col cols="12" sm="3">
																<v-select v-model="imageType" :items="['Upload', 'URL']" label="Image Type"></v-select>
															</v-col>
															<v-col cols="12" sm="9" v-if="imageType === 'Upload'">
																<input ref="attachment2" type="file" accept="image/png, image/jpeg, image/jpg" @change="onImageUpload" style="display: none" />
																<!-- hint="It’s recommended to use image with resolution approximately 1920 x 1080 pixels and recommended size is under 2MB, and for video it's recommended to use resolution of 1080 pixels." -->
																<v-text-field
																	v-model="imageName"
																	label="Prize Image"
																	placeholder="Upload Prize Image"
																	prepend-icon="mdi-image"
																	@click="openImageDialog()"
																	readonly
																	:rules="[(v) => !!v || 'Prize image is required']"
																>
																</v-text-field>
															</v-col>
															<v-col cols="12" sm="9" v-else>
																<v-text-field
																	v-model="prizeNew.image"
																	prepend-icon="mdi-image"
																	label="Prize Image"
																	placeholder="Prize Image Url"
																	hint="Please input image url with jpeg/jpg/png extension"
																	:rules="[(v) => !!v || 'Prize image is required']"
																></v-text-field> </v-col
														></v-row>
														<!-- END OF INPUT PRIZE IMAGE-->
													</v-col>
												</v-row>
											</v-container>
										</v-card-text>
										<v-alert class="ma-2" type="error" v-if="error.show">{{ error.content }}</v-alert>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn
												color="red darken-3 white--text"
												@click="
													isAddDialogPrize = false;
													error.show = false;
												"
												>Cancel</v-btn
											>
											<v-btn :disabled="!isValidFormPrize" type="submit" color="primary darken-1" @click="addPrize()">Add</v-btn>
										</v-card-actions>
									</v-form>
								</v-card>
							</v-dialog>
						</v-toolbar>
					</template>
					<template v-slot:item.title="{ item }">
						<div style="max-width: 300px; word-wrap: break-word" v-if="item.title != undefined">
							{{ item.title }}
						</div>
					</template>
					<template v-slot:item.type="{ item }">
						<span>{{ item.type.replace(/_/g, " ") }}</span>
					</template>
					<template v-slot:item.actions="{ item }">
						<v-icon small class="mr-2" @click="(isEditDialogPrize = true), (selectedPrize = item), (selectedPrizeEdit = { ...item }), (imageType = 'URL')">mdi-pencil</v-icon>
						<v-icon small @click="(isDeleteDialogPrize = true), (selectedPrize = item)">mdi-delete</v-icon>
					</template>
				</v-data-table>

				<!--EDIT DIALOG Prize-->
				<v-dialog v-model="isEditDialogPrize" max-width="500px">
					<v-card>
						<v-form v-model="isValidFormPrize">
							<v-card-title>
								<span class="headline">Edit Prize</span>
							</v-card-title>

							<v-card-text>
								<v-container>
									<v-row>
										<v-col cols="12" class="pb-1">
											<v-text-field v-model="selectedPrizeEdit.title" placeholder="Title" rounded filled persistent-hint :rules="fieldRules"> </v-text-field>
										</v-col>
										<v-col cols="12" class="pb-1">
											<v-select v-model="selectedPrizeEdit.type" placeholder="type" :items="prizeTypeList" :rules="fieldRules" rounded filled>
												<template v-slot:selection="{ item }">
													<span>{{ item.replace(/_/g, " ") }}</span>
												</template>
												<template v-slot:item="{ item }">
													<span>{{ item.replace(/_/g, " ") }}</span>
												</template>
											</v-select>
										</v-col>
										<v-col cols="12" v-if="selectedPrizeEdit.type == 'URL'">
											<v-text-field v-model="selectedPrizeEdit.url" placeholder="Url" :rules="fieldRules" rounded filled></v-text-field>
										</v-col>
										<v-col cols="12" v-if="selectedPrizeEdit.type == 'Text_and_image'">
											<v-text-field v-model="selectedPrizeEdit.description" placeholder="Description" :rules="fieldRules" rounded filled></v-text-field>
										</v-col>
										<!---upload image-->
										<v-col ref="box" id="box" v-if="selectedPrizeEdit.type == 'Text_and_image'">
											<img
												v-if="
													imageTemp &&
													imageTemp.startsWith('data') &&
													imageType == 'Upload' &&
													(imageName.toLowerCase().endsWith('.jpg') || imageName.toLowerCase().endsWith('.jpeg') || imageName.toLowerCase().endsWith('.png'))
												"
												:src="imageTemp"
												width="50%"
												height="150px"
												style="display: block; margin: 0 auto"
											/>
											<img
												v-else-if="selectedPrizeEdit.image && $root.isImage(selectedPrizeEdit.image)"
												:src="selectedPrizeEdit.image.toLowerCase().startsWith('http') ? selectedPrizeEdit.image : baseLocation + '/asset/file/' + selectedPrizeEdit.image"
												width="50%"
												height="150px"
												style="display: block; margin: 0 auto"
											/>
											<div v-else style="border: 5px solid black; width: 50%; height: 150px; margin: 0 auto"></div>
											<!--- INPUT PRIZE IMAGE-->
											<v-row>
												<v-col cols="12" sm="3">
													<v-select v-model="imageType" :items="['Upload', 'URL']" label="Image Type"></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="imageType === 'Upload'">
													<input ref="attachment2" type="file" accept="image/png, image/jpeg, image/jpg" @change="onImageUpload" style="display: none" />
													<!-- hint="It’s recommended to use image with resolution approximately 1920 x 1080 pixels and recommended size is under 2MB, and for video it's recommended to use resolution of 1080 pixels." -->
													<v-text-field v-model="imageName" label="Prize Image" placeholder="Upload Image" prepend-icon="mdi-image" @click="openImageDialog()" readonly :rules="[(v) => !!v || 'Prize image is required']">
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="selectedPrizeEdit.image"
														prepend-icon="mdi-image"
														label="Image"
														placeholder="Prize Image Url"
														hint="Please input image url with jpeg/jpg/png extension"
														:rules="[(v) => !!v || 'Prize image is required']"
													></v-text-field> </v-col
											></v-row>
											<!-- END OF INPUT PRIZE IMAGE-->
										</v-col>
									</v-row>
								</v-container>
							</v-card-text>

							<v-alert class="ma-2" type="error" v-if="error.show">{{ error.content }}</v-alert>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn
									color="red darken-3 white--text"
									@click="
										isEditDialogPrize = false;
										error.show = false;
									"
									>Cancel</v-btn
								>
								<v-btn :disabled="!isValidFormPrize" type="submit" color="primary darken-1" @click="editPrize()">Save</v-btn>
							</v-card-actions>
						</v-form>
					</v-card>
				</v-dialog>

				<!---DELETE DIALOG Prize--->
				<v-dialog v-model="isDeleteDialogPrize" max-width="300">
					<v-card>
						<v-card-title class="headline">Delete Prize</v-card-title>
						<v-card-text>Are you sure you want to delete this prize?</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="red darken-1" text @click="isDeleteDialogPrize = false">CANCEL</v-btn>
							<v-btn color="green darken-1" text @click="deletePrize(selectedPrize)">YES</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-card>
		</v-card>
	</div>
</template>

<script>
import axios from "axios";

export default {
	props: ["experienceId"],
	data() {
		return {
			leaderboard: {
				background: "",
				pointSystem: "",
				pointSystemList: [],
				prizeDataList: []
			},
			attachment: null,
			attachment2: null,
			pointSystemNew: {
				title: "",
				description: "",
				point: 0,
				specificId: [],
				specificValue: [],
				specificLinkTo: {}
			},
			pointDescriptionList: [],
			headers: [
				{
					text: "Title",
					align: "start",
					sortable: "true",
					value: "title"
				},
				{
					text: "Point Description",
					sortable: "true",
					value: "description"
				},
				{
					text: "Point Earned",
					value: "point"
				},
				{
					text: "Actions",
					value: "actions",
					sortable: false
				}
			],
			isAddDialog: false,
			isEditDialog: false,
			isDeleteDialog: false,
			isValidForm: false,
			selectedPointSystem: {},
			selectedPointSystemEdit: {},
			fieldRules: [(v) => (!!v && /.*[^ ].*/.test(v)) || "This field is required!"],
			experience: {},
			baseLocation: axios.defaults.baseURL,
			error: { show: false, content: "" },

			leaderboardLibraryList: { data: [], page: 1, size: 15, length: 0, total: 0 },
			dialogResetSuccess: false,
			dialogAreYouSure: false,
			dialogLeaderboardLibrary: false,
			dialogSuccess: false,

			backgroundImageName: "",
			backgroundFileName: "",
			backgroundTemp: "",
			isSpecific: false,
			isSpecificEdit: false,
			roomList: [],
			livePresentationList: [],
			nonlivePresentationList: [],
			linkToList: [],
			tagFilter: [],
			tagList: [],
			isEditRoomChanged: false,

			isAddDialogPrize: false,
			isValidFormPrize: false,
			isEditDialogPrize: false,
			isDeleteDialogPrize: false,
			prizeNew: {
				title: "",
				description: "",
				image: "",
				url: ""
			},
			selectedPrize: {},
			selectedPrizeEdit: {},
			prizeTypeList: [],
			headersPrize: [
				{
					text: "Title",
					align: "start",
					sortable: "true",
					value: "title"
				},
				{
					text: "Type",
					sortable: "true",
					value: "type"
				},
				{
					text: "Actions",
					value: "actions",
					sortable: false
				}
			],

			imageType: "Upload",
			imageName: "",
			imageTemp: "",
			rowsPerPage: [15, 30, 60]
		};
	},
	mounted() {
		this.listLeaderboardLibraryList();
		this.getPointDescriptionList();
		this.getPrizeTypeList();
		this.getLeaderboard();
		this.getStructureList();
		this.getNonLivePresentationList();
		this.getLivePresentationList();
		this.listTag();
	},
	methods: {
		listLeaderboardLibraryList() {
			axios.post("/system/leaderboardlibrary/list", {
					planFilter: [],
					tagFilter: this.tagFilter,
					tenantPlanId: this.$store.state.principal.tenantPlanId,
					page: this.leaderboardLibraryList.page,
					size: this.leaderboardLibraryList.size
				}).then((response) => {
				this.leaderboardLibraryList = response.data;
				// Check if small asset is exist and use it
				let vm = this;
				this.leaderboardLibraryList.data.map(obj => {
					vm.$root.isImageExist(vm.$root.smallAsset(obj.background), function(status) {
						if (status) {
							obj.background = vm.$root.smallAsset(obj.background)
						}
					});
					return obj;
				});
			});
		},
		listTag() {
			axios.get("/system/leaderboardlibrary/tag/list").then((response) => {
				this.tagList = response.data;
			});
		},
		resetLibrary() {
			this.planFilter = [];
			this.tagFilter = [];
			this.leaderboardLibraryList.page = 1;
			this.leaderboardLibraryList.size = 15;
			this.listLeaderboardLibrary();
		},
		getPointDescriptionList() {
			axios
				.post("/system/enumeration/activitylogtype/list", { entity: this.leaderboard })
				.then((response) => {
					this.pointDescriptionList = response.data;
				})
				.catch();
		},
		getLeaderboard() {
			axios
				.post("/system/leaderboard", { experienceId: this.experienceId })
				.then((response) => {
					if (response.data == null) {
						this.leaderboard.experienceId = this.experienceId;
						axios
							.post("/system/leaderboard/save", { entity: this.leaderboard })
							.then(() => {
								this.getLeaderboard();
							})
							.catch();
					} else {
						this.leaderboard = response.data;
						this.backgroundFileName = this.leaderboard.background;
						if (!this.leaderboard.pointSystemList) {
							this.leaderboard.pointSystemList = [];
						}
						if (!this.leaderboard.prizeDataList) {
							this.leaderboard.prizeDataList = [];
						}
					}
				})
				.catch();
		},
		addPointSystem() {
			if (!this.isSpecific) {
				this.pointSystemNew.specificId = [];
				this.pointSystemNew.specificLinkTo = {};
			}
			if(this.pointSystemNew.specificValueData){
				if(this.pointSystemNew.specificValueData.includes(",")){
					let valueList = this.pointSystemNew.specificValueData.split(",");
					let valueListEscaped = [];
					for(let value in valueList){
						valueListEscaped.push(value.trim());
					}
					this.pointSystemNew.specificValue = valueListEscaped;
				} else {
					this.pointSystemNew.specificValue = [this.pointSystemNew.specificValueData.trim()];
				}
			}
			var match = false;
			this.leaderboard.pointSystemList.forEach((element) => {
				if (element.description == this.pointSystemNew.description && !match) {
					match = true;
					if (element.specificId && this.pointSystemNew.specificId && element.specificId.length > 0) {
						if (element.specificId.length == this.pointSystemNew.specificId.length) {
							//array to save if matched id is found
							let foundMatch = [];

							//check all id in the current element
							for (let index = 0; index < element.specificId.length; index++) {
								foundMatch[index] = false;
								// check current selected specific id in element array with pointSystemNew specific id
								for (let j = 0; j < this.pointSystemNew.specificId.length; j++) {
									//if pointSystemNew contain the same id with current element specific id then set foundMatch array as true
									if (element.specificId[index] == this.pointSystemNew.specificId[j]) {
										foundMatch[index] = true;
										break;
									}
								}
							}
							for (let j = 0; j < this.pointSystemNew.specificId.length; j++) {
								//check all foundMatch, if there are 1 false then it means we don't have the exact same point system in our current leaderboard point system list
								if (!foundMatch[j]) {
									match = false;
								}
							}
						} else {
							match = false;
						}
					} else if (element.specificValue.length > 0 || this.pointSystemNew.specificValue.length > 0) {
						if (element.specificValue.length == this.pointSystemNew.specificValue.length) {
							
							//array to save if matched id is found
							let foundMatch = [];

							//check all id in the current element
							for (let index = 0; index < element.specificValue.length; index++) {
								foundMatch[index] = false;
								// check current selected specific id in element array with pointSystemNew specific id
								for (let j = 0; j < this.pointSystemNew.specificValue.length; j++) {
									//if pointSystemNew contain the same id with current element specific id then set foundMatch array as true
									if (element.specificValue[index].trim() == this.pointSystemNew.specificValue[j].trim()) {
										foundMatch[index] = true;
										break;
									}
								}
							}
							for (let j = 0; j < this.pointSystemNew.specificValue.length; j++) {
								//check all foundMatch, if there are 1 false then it means we don't have the exact same point system in our current leaderboard point system list
								if (!foundMatch[j]) {
									match = false;
								}
							}
						} else {
							match = false;
						}
					}
					//check if leaderboard current point system list contain the same room id with pointSystemNew
					else if (element.specificLinkTo && this.pointSystemNew.specificLinkTo && this.pointSystemNew.specificLinkTo.roomId && element.specificLinkTo.roomId && element.specificLinkTo.roomId == this.pointSystemNew.specificLinkTo.roomId) {
						if (element.specificLinkTo.linkToId && this.pointSystemNew.specificLinkTo.linkToId) {
							if (element.specificLinkTo.linkToId.length == this.pointSystemNew.specificLinkTo.linkToId.length) {
								//array to save if matched id is found
								var foundMatchLinkTo = [];
								//check all id in the current element
								for (let index = 0; index < element.specificLinkTo.linkToId.length; index++) {
									foundMatchLinkTo[index] = false;
									// check current selected specific link to id in element array with pointSystemNew specific link to id
									for (let j = 0; j < this.pointSystemNew.specificLinkTo.linkToId.length; j++) {
										if (element.specificLinkTo.linkToId[index] == this.pointSystemNew.specificLinkTo.linkToId[j]) {
											foundMatchLinkTo[index] = true;
											break;
										}
									}
								}
								for (let j = 0; j < this.pointSystemNew.specificLinkTo.linkToId.length; j++) {
									//check all foundMatch, if there are 1 false then it means we don't have the exact same point system in our current leaderboard point system list
									if (!foundMatchLinkTo[j]) {
										match = false;
									}
								}
							} else {
								match = false;
							}
						}
					} else if (
						//to check if there  are same description (example Visit_room) but 1 have specific id and 1 doesn't then match should be false
						(element.specificId === undefined && this.pointSystemNew.specificId !== undefined) ||
						(element.specificId !== undefined && this.pointSystemNew.specificId === undefined) ||
						(element.specificLinkTo !== undefined && this.pointSystemNew.specificLinkTo === undefined) ||
						(element.specificLinkTo === undefined && this.pointSystemNew.specificLinkTo !== undefined) ||
						(element.specificLinkTo && this.pointSystemNew.specificLinkTo && element.specificLinkTo.linkToId === undefined && this.pointSystemNew.specificLinkTo.linkToId !== undefined) ||
						(element.specificLinkTo && this.pointSystemNew.specificLinkTo && element.specificLinkTo.linkToId !== undefined && this.pointSystemNew.specificLinkTo.linkToId === undefined)
					) {
						match = false;
					}
				}
			});

			if (!match) {
				this.leaderboard.pointSystemList.push(this.pointSystemNew);
				axios
					.post("/system/leaderboard/save", { entity: this.leaderboard })
					.then(() => {
						this.pointSystemNew = {
							title: "",
							description: "",
							point: 0,
							specificId: [],
							specificLinkTo: {}
						};
						this.isAddDialog = false;
						this.getLeaderboard();
						this.error.show = false;
					})
					.catch();
			} else {
				this.error.content = "You already have the same point system";
				this.error.show = true;
			}
		},
		editPointSystem() {
			if (!this.isSpecificEdit) {
				this.selectedPointSystemEdit.specificId = [];
				this.selectedPointSystemEdit.specificLinkTo = {};
			}

			if(this.selectedPointSystemEdit.specificValueData && this.selectedPointSystemEdit.specificValueData != null){
				if(this.selectedPointSystemEdit.specificValueData.includes(",")){
					let valueList = this.selectedPointSystemEdit.specificValueData.split(",");
					let valueListEscaped = [];
					for(let value of valueList){
						valueListEscaped.push(value.trim());
					}
					this.selectedPointSystemEdit.specificValue = valueListEscaped;
				} else {
					this.selectedPointSystemEdit.specificValue = [this.selectedPointSystemEdit.specificValueData.trim()];
				}
			} else {
				this.selectedPointSystemEdit.specificValue = [];
			}

			let row = this.leaderboard.pointSystemList.indexOf(this.selectedPointSystem);
			var match = false;
			//check if tenant edited the current selected point system (so it won't show error when saving because containing the same value)
			if (
				this.selectedPointSystem.specificId != this.selectedPointSystemEdit.specificId ||
				this.selectedPointSystem.specificLinkTo != this.selectedPointSystemEdit.specificLinkTo ||
				this.selectedPointSystem.description != this.selectedPointSystemEdit.description
			) {
				this.leaderboard.pointSystemList.forEach((element) => {
					element.specificValue = element.specificValue == null ? [] : element.specificValue;

					if (element.description == this.selectedPointSystemEdit.description && !match) {
						match = true;
						if (element.specificId && this.selectedPointSystemEdit.specificId && element.specificId.length > 0) {
							if (element.specificId.length == this.selectedPointSystemEdit.specificId.length) {
								//array to save if matched id is found
								var foundMatch = [];
								//check all id in the current element
								for (let index = 0; index < element.specificId.length; index++) {
									foundMatch[index] = false;
									// check current selected specific link to id in element array with pointSystemNew specific link to id
									for (let j = 0; j < this.selectedPointSystemEdit.specificId.length; j++) {
										if (element.specificId[index] == this.selectedPointSystemEdit.specificId[j]) {
											foundMatch[index] = true;
											break;
										}
									}
								}
								for (let j = 0; j < this.selectedPointSystemEdit.specificId.length; j++) {
									//check all foundMatch, if there are 1 false then it means we don't have the exact same point system in our current leaderboard point system list
									if (!foundMatch[j]) {
										match = false;
									}
								}
							} else {
								match = false;
							}
						}
						else if (element.specificValue.length > 0 || this.selectedPointSystemEdit.specificValue.length > 0) {
							if (element.specificValue.length == this.selectedPointSystemEdit.specificValue.length) {
							
								//array to save if matched id is found
								let foundMatch = [];

								//check all id in the current element
								for (let index = 0; index < element.specificValue.length; index++) {
									foundMatch[index] = false;
									// check current selected specific id in element array with pointSystemNew specific id
									for (let j = 0; j < this.selectedPointSystemEdit.specificValue.length; j++) {
										//if selectedPointSystemEdit contain the same id with current element specific id then set foundMatch array as true
										if (element.specificValue[index].trim() == this.selectedPointSystemEdit.specificValue[j].trim()) {
											foundMatch[index] = true;
											break;
										}
									}
								}
								for (let j = 0; j < this.selectedPointSystemEdit.specificValue.length; j++) {
									//check all foundMatch, if there are 1 false then it means we don't have the exact same point system in our current leaderboard point system list
									if (!foundMatch[j]) {
									match = false;
									}
								}
							} else {
								match = false;
							}
						}
						//check if current specific link to room id is the same with pointSystemNew specific link to room id
						else if (
							element.specificLinkTo &&
							this.selectedPointSystemEdit.specificLinkTo &&
							this.selectedPointSystemEdit.specificLinkTo.roomId &&
							element.specificLinkTo.roomId &&
							element.specificLinkTo.roomId == this.selectedPointSystemEdit.specificLinkTo.roomId
						) {
							if (element.specificLinkTo.linkToId && this.selectedPointSystemEdit.specificLinkTo.linkToId) {
								if (element.specificLinkTo.linkToId.length == this.selectedPointSystemEdit.specificLinkTo.linkToId.length) {
									//array to save if matched id is found
									var foundMatchLinkTo = [];
									//check all id in the current element
									for (let index = 0; index < element.specificLinkTo.linkToId.length; index++) {
										foundMatchLinkTo[index] = false;
										// check current selected specific link to id in element array with pointSystemNew specific link to id
										for (let j = 0; j < this.selectedPointSystemEdit.specificLinkTo.linkToId.length; j++) {
											if (element.specificLinkTo.linkToId[index] == this.selectedPointSystemEdit.specificLinkTo.linkToId[j]) {
												foundMatchLinkTo[index] = true;
												break;
											}
										}
									}
									for (let j = 0; j < this.selectedPointSystemEdit.specificLinkTo.linkToId.length; j++) {
										//check all foundMatch, if there are 1 false then it means we don't have the exact same point system in our current leaderboard point system list
										if (!foundMatchLinkTo[j]) {
											match = false;
										}
									}
								} else {
									match = false;
								}
							}
						} else if (
							//to check if there  are same description (example Visit_room) but 1 have specific id and 1 doesn't then match should be false
							(element.specificId === undefined && this.selectedPointSystemEdit.specificId !== undefined) ||
							(element.specificId !== undefined && this.selectedPointSystemEdit.specificId === undefined) ||
							(element.specificLinkTo !== undefined && this.selectedPointSystemEdit.specificLinkTo === undefined) ||
							(element.specificLinkTo === undefined && this.selectedPointSystemEdit.specificLinkTo !== undefined) ||
							(element.specificLinkTo && this.selectedPointSystemEdit.specificLinkTo && element.specificLinkTo.linkToId === undefined && this.selectedPointSystemEdit.specificLinkTo.linkToId !== undefined) ||
							(element.specificLinkTo && this.selectedPointSystemEdit.specificLinkTo && element.specificLinkTo.linkToId !== undefined && this.selectedPointSystemEdit.specificLinkTo.linkToId === undefined)
						) {
							match = false;
						}
						
						if (match && row == this.leaderboard.pointSystemList.indexOf(element)) {
							match = false;
						}
					}
				});
			}
			if (!match) {
				this.leaderboard.pointSystemList[this.leaderboard.pointSystemList.indexOf(this.selectedPointSystem)] = this.selectedPointSystemEdit;
				axios
					.post("/system/leaderboard/save", { entity: this.leaderboard })
					.then(() => {
						this.isEditDialog = false;
						window.location.reload();
					})
					.catch();
			} else {
				this.error.content = "You already have the same point system";
				this.error.show = true;
			}
		},
		deletePointSystem(pointSystem) {
			this.leaderboard.pointSystemList.splice(this.leaderboard.pointSystemList.indexOf(pointSystem), 1);
			axios
				.post("/system/leaderboard/save", { entity: this.leaderboard })
				.then(() => {
					this.pointSystemNew.description = "";
					this.pointSystemNew.point = 0;
					this.getLeaderboard();
				})
				.catch();
			this.isDeleteDialog = false;
		},
		saveLeaderboardBackground() {
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.leaderboard));
			if (this.attachment) {
				formData.append("attachment", this.attachment);
			}
			axios
				.post("/system/leaderboard/save", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					this.dialogSuccess = true;
					this.getLeaderboard();
				})
				.catch();
		},
		resetLeaderboardPoint() {
			axios
				.post("/system/leaderboard/reset/point", { experienceId: this.experienceId })
				.then(() => {
					this.dialogResetSuccess = true;
				})
				.catch();
		},
		onBackgroundUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.backgroundTemp = fr.result;

					this.attachment = files[0]; // this is an image file that can be sent to server...
				});
				this.backgroundFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.backgroundImageName = files[0].name;
			} else {
				this.attachment = null;
			}
		},
		openBackgroundDialog() {
			this.$refs.attachment.click();
		},
		closeLibraryDialog(library) {
			this.leaderboard.background = library.background;
			if (this.leaderboard.background) {
				this.leaderboard.background = this.$root.reverseToOriginal(this.leaderboard.background);
			}
			this.dialogLeaderboardLibrary = false;
			this.attachment = null;
			this.backgroundTemp = "";
			this.backgroundImageName = "";
			this.backgroundFileName = this.leaderboard.background;
		},
		getStructureList() {
			axios
				.post("/system/structure/list", { experienceId: this.experienceId })
				.then((response) => {
					this.roomList = response.data;
				})
				.catch();
		},
		getLivePresentationList() {
			this.livePresentationList = [];
			axios
				.post("/system/presentation/live/list", { experienceId: this.experienceId })
				.then((response) => {
					this.livePresentationList = response.data;
				})
				.catch();
		},
		getNonLivePresentationList() {
			this.nonlivePresentationList = [];
			axios
				.post("/system/presentation/nonlive/list", { experienceId: this.experienceId })
				.then((response) => {
					this.nonlivePresentationList = response.data;
				})
				.catch();
		},
		changeLinkToList() {
			//when new point system description is changed or room id is changed for specificLinkTo, the list for link to will be changed with this method
			this.linkToList = [];
			if (
				this.roomList &&
				this.pointSystemNew.specificLinkTo.roomId &&
				this.roomList.find((room) => room.id === this.pointSystemNew.specificLinkTo.roomId).linkToDataList &&
				this.roomList.find((room) => room.id === this.pointSystemNew.specificLinkTo.roomId).linkToDataList.length > 0
			) {
				this.pointSystemNew.specificId = [];
				this.roomList
					.find((room) => room.id === this.pointSystemNew.specificLinkTo.roomId)
					.linkToDataList.forEach((element) => {
						if (element.type == "URL") {
							//list for current tab link to
							if (this.pointSystemNew.description == "Room_url_current_tab" && element.target && element.target == "Current Tab") {
								this.linkToList.push(element);
							}
							//list for new tab link to
							else if (this.pointSystemNew.description == "Room_url_new_tab" && element.target && element.target == "New Tab") {
								this.linkToList.push(element);
							}
							//list for dialog link to (video, etc.)
							else if (this.pointSystemNew.description == "Watch_video_in_room" && element.target && element.target == "Dialog") {
								this.linkToList.push(element);
							}
						}
					});
			}
		},
		changeLinkToListEdit() {
			//when edit point system description is changed or room id is changed for specificLinkTo, the list for link to will be changed with this metho
			this.linkToList = [];
			if (
				this.roomList &&
				this.selectedPointSystemEdit.specificLinkTo.roomId &&
				this.roomList.find((room) => room.id === this.selectedPointSystemEdit.specificLinkTo.roomId).linkToDataList &&
				this.roomList.find((room) => room.id === this.selectedPointSystemEdit.specificLinkTo.roomId).linkToDataList.length > 0
			) {
				if (this.isEditRoomChanged) {
					this.selectedPointSystemEdit.specificLinkTo.linkToId = [];
				}
				this.roomList
					.find((room) => room.id === this.selectedPointSystemEdit.specificLinkTo.roomId)
					.linkToDataList.forEach((element) => {
						if (element.type == "URL") {
							//list for current tab link to
							if (this.selectedPointSystemEdit.description == "Room_url_current_tab" && element.target && element.target == "Current Tab") {
								this.linkToList.push(element);
							}
							//list for new tab link to
							else if (this.selectedPointSystemEdit.description == "Room_url_new_tab" && element.target && element.target == "New Tab") {
								this.linkToList.push(element);
							}
							//list for dialog link to (video, etc.)
							else if (this.selectedPointSystemEdit.description == "Watch_video_in_room" && element.target && element.target == "Dialog") {
								this.linkToList.push(element);
							}
						}
					});
			}
			
			if(this.selectedPointSystemEdit.specificValue != null && this.selectedPointSystemEdit.specificValue.length > 0){
				this.selectedPointSystemEdit.specificValueData = this.selectedPointSystemEdit.specificValue.toString().replaceAll("[", "").replaceAll("]", "");
			}
		},
		onImageUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.imageTemp = fr.result;
					this.attachment2 = files[0]; // this is an image file that can be sent to server...
				});
				this.imageName = files[0].name;
			} else {
				this.attachment2 = null;
			}
		},
		openImageDialog() {
			this.$refs.attachment2.click();
		},
		addPrize() {
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.leaderboard));
			formData.append("prize", JSON.stringify(this.prizeNew));
			formData.append("index", -1);
			if (this.attachment2 && this.imageType == "Upload") {
				formData.append("attachment2", this.attachment2);
			}
			axios
				.post("/system/leaderboard/prize/save", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					this.prizeNew = {
						image: "",
						title: "",
						description: "",
						url: ""
					};
					this.isAddDialogPrize = false;
					this.getLeaderboard();
					this.error.show = false;
				})
				.catch();
		},
		editPrize() {
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.leaderboard));
			formData.append("prize", JSON.stringify(this.selectedPrizeEdit));
			formData.append("index", this.leaderboard.prizeDataList.indexOf(this.selectedPrize));
			if (this.attachment2 && this.imageType == "Upload") {
				formData.append("attachment2", this.attachment2);
			}
			axios
				.post("/system/leaderboard/prize/save", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					this.isEditDialogPrize = false;
					this.getLeaderboard();
					this.error.show = false;
				})
				.catch();
		},
		deletePrize(prize) {
			this.leaderboard.prizeDataList.splice(this.leaderboard.prizeDataList.indexOf(prize), 1);
			axios
				.post("/system/leaderboard/save", { entity: this.leaderboard })
				.then(() => {
					this.getLeaderboard();
				})
				.catch();
			this.isDeleteDialogPrize = false;
		},
		getPrizeTypeList() {
			axios
				.get("/system/enumeration/prize/type/list")
				.then((response) => {
					this.prizeTypeList = response.data;
				})
				.catch();
		}
	}
};
</script>